import { useCallback, useEffect, useState } from 'react';
import {
	getUserProperty,
	setUserProperty,
} from '@jira/admin-pages__performance/src/setUserProperty.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';

export const useHasSeenOnboarding = (key: string) => {
	const accountId = useAccountId();
	const [isOnboardingActive, setIsOnboardingActive] = useState(false);

	const getHasSeenOnboarding = useCallback(
		async (id: string) => {
			const response = await getUserProperty({
				accountId: id,
				propertyKey: key,
				defaultValue: false,
			});

			return response.value;
		},
		[key],
	);

	const setHasSeenOnboarding = useCallback(async () => {
		setIsOnboardingActive(false);
		if (accountId !== null) {
			await setUserProperty({
				accountId,
				propertyKey: key,
				propertyValue: true,
			});
		}
	}, [accountId, key]);

	const fetchOnboardingState = useCallback(async () => {
		if (accountId !== null) {
			const response = await getHasSeenOnboarding(accountId);
			setIsOnboardingActive(!response);
		}
	}, [accountId, getHasSeenOnboarding]);

	useEffect(() => {
		fetchOnboardingState();
	}, [fetchOnboardingState]);

	return [isOnboardingActive, setHasSeenOnboarding] as const;
};
